import { useState } from 'react';
import parse from 'html-react-parser';
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useMyIntl } from 'my-intl';

import { styles } from './constants';

import './about.scss';

function About() {
  const { translateMessage } = useMyIntl();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickClose = () => {
    setOpen(false);
  };

  return (
    <Grid container id={styles.ids.about}>
      <Grid size={6} className="imagesConteiner">
        <img src="images/ballet-dancer.jpeg" alt="Ballet dancer" className="balletDancer"></img>
        <img src="images/main-coach.jpg" alt="Main coach" className="coach"></img>
      </Grid>
      <Grid size={6} className="textContainer">
        <Card sx={{ backgroundColor: 'transparent' }}>
          <CardContent>
            <Typography letterSpacing={'0.7rem'} textTransform={'uppercase'} paddingLeft={'2rem'}>
              {translateMessage('about.club')}
            </Typography>
            <Typography component="div" variant="h2" display={'flex'} alignItems={'center'} padding={'2rem 2rem 0'}>
              {translateMessage('about.title')}
            </Typography>
            <Typography padding={'2rem'} lineHeight={'2rem'}>
              {translateMessage('about.text')}
            </Typography>
            <Typography paddingLeft={'2rem'}>
              <Button sx={{ borderColor: '#000', color: '#000' }} variant="outlined" onClick={handleClickOpen}>
                {translateMessage('about.dialog.button')}
              </Button>
              <Dialog
                aria-labelledby="customized-dialog-title"
                fullWidth
                maxWidth="md"
                open={open}
                onClose={handleClickClose}
              >
                <DialogTitle id="customized-dialog-title">
                  {translateMessage('about.dialog.title')}
                  <img src="images/ice_sports_varna_logo.png" alt="Ice Sports Varna" />
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={handleClickClose}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                  <Typography gutterBottom>{parse(translateMessage('about.dialog.text'))}</Typography>
                </DialogContent>
              </Dialog>
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default About;
